function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m48 64h-32a16.0007 16.0007 0 0 1 -16-16v-32a16.0007 16.0007 0 0 1 16-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1 -16 16",
  fill: "#2d0f1e"
}), React.createElement("path", {
  d: "m30 18h18a9.0006 9.0006 0 0 0 .92-17.954c-.306-.017-.609-.046-.92-.046h-32a16.0007 16.0007 0 0 0 -16 16v32a30.0007 30.0007 0 0 1 30-30",
  fill: "#501432"
}), React.createElement("path", {
  d: "m48 32a16 16 0 1 0 16 16v-32a16 16 0 0 1 -16 16"
}), React.createElement("path", {
  d: "m34 14a1.9994 1.9994 0 0 1 2-2h4.229a2 2 0 0 1 1.961 1.609 7.9559 7.9559 0 0 0 7.81 6.391 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 15.9169 15.9169 0 0 1 -8-2.143v16.143a13.9993 13.9993 0 1 1 -14-14 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 6.0005 6.0005 0 1 0 6 6z",
  fill: "#fe2c55"
}), React.createElement("path", {
  d: "m32 12a1.9994 1.9994 0 0 1 2-2h4.229a2 2 0 0 1 1.961 1.609 7.9559 7.9559 0 0 0 7.81 6.391 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 15.9169 15.9169 0 0 1 -8-2.143v16.143a13.9993 13.9993 0 1 1 -14-14 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 6.0005 6.0005 0 1 0 6 6z",
  fill: "#25f4ee"
}), React.createElement("path", {
  d: "m22.876 45.124a6.0005 6.0005 0 0 0 11.124-3.124v-28a1.9994 1.9994 0 0 1 2-2h4.229c.017 0 .033 0 .049.001a7.9381 7.9381 0 0 0 3.173 4.577 7.9586 7.9586 0 0 0 6.549 3.422v4a1.9994 1.9994 0 0 1 -2 2 15.9169 15.9169 0 0 1 -8-2.143v16.143a14 14 0 0 1 -22.849 10.849 14.0007 14.0007 0 0 1 10.849-22.849v4a1.9994 1.9994 0 0 1 -2 2 6.0009 6.0009 0 0 0 -3.124 11.124z",
  fill: "#fff"
}));

var SvgTiktok = function SvgTiktok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTiktok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiktok.6e1ad303.svg";
export { ForwardRef as ReactComponent };